import React from 'react'

const button = props => <div className='filter-button' onClick={props.onClick} style={{ background: props.active ? props.appState.colorTheme.secondary : 'inherit' }}>
  <p>{props.text}</p>
</div>

export default button